import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCT_CATOGORY_LIST_SUCCESS,
    GET_PRODUCT_CATOGORY_LIST_FAILURE,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';
import { convertObjectToQueryParams } from 'src/utils/util';
import { 
    getProductsByBrandOrSuperCategoryDataService,
    getProductsByBrandOrSuperCategoryApiEndpoint 
} from 'src/pages/more/pages/productGuide/redux/services';

export default function* getProductFilterCatogries(action) {
    const { countryISOCode } = yield select((state) => ({
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode
    }));
    const isMastOrder = false;
    const queryParams = convertObjectToQueryParams({
        ...action.payload,
        isMastOrder: isMastOrder,
    });
    const apiEndpoint = getProductsByBrandOrSuperCategoryApiEndpoint(queryParams);
    
    try {
        let result = yield getProductsByBrandOrSuperCategoryDataService(queryParams);
        // eslint-disable-next-line no-debugger
        let updatedData = {};
        let brandRefineData = [];
        if (result?.subCategoryRefineData) {
            updatedData = result?.subCategoryRefineData?.map((cat) => {
                return {
                    ...cat,
                    classificationRefineData: cat?.classificationRefineData.map(
                        (item) => {
                            return {
                                ...item,
                                isChecked: item.selected
                                    ? item.selected
                                    : false,
                            };
                        }
                    ),
                };
            });
        }
        //added these function for brand filter
        if (result?.brandRefineData) {
            brandRefineData = result.brandRefineData?.map((item) => {
                return {
                    ...item,
                    isChecked: item.selected ? item.selected : false,
                };
            });
        }
        //added these function for brand filter
        if (result?.brandRefineData?.length > 0) {
            result.brandRefineData = brandRefineData;
        }

        if (result?.subCategoryRefineData?.length > 0) {
            result.subCategoryRefineData = updatedData;
        }
        yield put({
            type: GET_PRODUCT_CATOGORY_LIST_SUCCESS,
            productGuideData: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: apiEndpoint,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCT_CATOGORY_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}